// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

import Rails from "@rails/ujs"
import Turbolinks from "turbolinks"
import * as ActiveStorage from "@rails/activestorage"
import "channels"

import * as jquery from "jquery"
import * as bootstrap from "bootstrap"

Rails.start()
Turbolinks.start()
ActiveStorage.start()

const images = require.context("../images", true)
const imagePath = name => images(name, true)

$(document).on("turbolinks:load", function () {
  // console.log("loaded")
  $("a.check-all-checkboxes").on("click", function (e) {
    e.preventDefault()
    $(this).parent("form").find("input[type='checkbox']").prop("checked", true)
  })
  $("a.uncheck-all-checkboxes").on("click", function (e) {
    e.preventDefault()
    $(this).parent("form").find("input[type='checkbox']").prop("checked", false)
  })
})
